import { useState, createContext, useEffect } from "react";

import {BrowserRouter, Routes, Route } from "react-router-dom";
import './App.css';

import Login from "./components/Login";
import Home from "./components/Home";
import AddNew from "./components/addNew";
import AddNewStaff from "./components/addNewStaff";
import Profile from "./components/Profile";
import ProfileStaff from "./components/ProfileStaff";
import UpdateProfile from "./components/updateProfile";
import UpdateProfileStaff from "./components/updateProfileStaff";
import Archived from "./components/archived";
import ArchivedStaff from "./components/archivedStaff";
import Subbie from "./components/subbie";
import Paye from "./components/paye";
import ExpirySoon from "./components/ExpirySoon";
import SiteStaff from "./components/siteStaff";
import OfficeStaff from "./components/officeStaff";
import ViewAll from "./components/ViewAll";
import ViewAllStaff from "./components/viewAllStaff";
import ProfileArchived from "./components/profileArchived";
import ProfileArchivedStaff from "./components/profileArchivedStaff";
import Filter from "./components/filter";
import Filter2 from "./components/filter2";
import Dpc from "./components/dpc";
import Services from "./components/services";
import CurrentlyinRehab from "./components/currentlyinRehab"
import DailySumbission from "./components/dailySumbissions";
import SendVerificationEmail from "./components/sendVerificationEmail";

import DataContext from "./context/context";

import { getDoc, doc} from "firebase/firestore";
import { db } from "./firebase";

function App() {

  const [data, setdata] = useState()

  useEffect(() => {
    getData()
  }, [])

  let d;

  let getData = async () =>{
    const docRef = doc(db, "fields", "dropdowns");
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      await setdata(docSnap.data())
      d=docSnap.data();
      
    }
    setdata(d)
  
  }
  
  
  return (
  <DataContext.Provider value={data}>
   <BrowserRouter>
      <Routes>
        <Route path="/" exact element={<Login />}/>
        <Route path="home" exact element={<Home />}/>
        <Route path="addnew" exact element={<AddNew />}/>
        <Route path="addnewStaff" exact element={<AddNewStaff />}/>
        <Route path="profile" exact element={<Profile />}/>
        <Route path="profileStaff" exact element={<ProfileStaff />}/>
        <Route path="profileUpdate" exact element={<UpdateProfile />}/>
        <Route path="profileUpdateStaff" exact element={<UpdateProfileStaff />}/>
        <Route path="archived" exact element={<Archived />}/>
        <Route path="archivedStaff" exact element={<ArchivedStaff />}/>
        <Route path="subbie" exact element={<Subbie />}/>
        <Route path="paye" exact element={<Paye />}/>
        <Route path="expirysoon" exact element={<ExpirySoon />}/>
        <Route path="siteStaff" exact element={<SiteStaff />}/>
        <Route path="officeStaff" exact element={<OfficeStaff />}/>
        <Route path="viewAll" exact element={<ViewAll />}/>
        <Route path="viewAllStaff" exact element={<ViewAllStaff />}/>
        <Route path="profileArchived" exact element={<ProfileArchived />}/>
        <Route path="profileArchivedStaff" exact element={<ProfileArchivedStaff />}/>
        <Route path="filter" exact element={<Filter />}/>
        <Route path="filter2" exact element={<Filter2 />}/>
        <Route path="dpc" exact element={<Dpc />}/>
        <Route path="dailySumbissions" exact element={<DailySumbission />}/>
        <Route path="services" exact element={<Services />}/>
        <Route path="currentlyinRehab" exact element={<CurrentlyinRehab />}/>
        <Route path="verifyEmail" exact element={<SendVerificationEmail />}/>

      </Routes>
   </BrowserRouter>
   </DataContext.Provider>

  );
}

export default App;
